$(document).ready(function () {

  $(".slide-content").hover(function() {
    var $overlay = $(this).closest(".border-container").find(".overlay");

    // position overlay at center of
    $overlay.css("left", $(this).offset().left + ($(this).width()/2));
    $overlay.css("top", $(this).offset().top + ($(this).height()/2));

    // animate overlay
    $overlay.addClass("animate");

    // animate background
    $overlay.closest(".border-container").addClass("animate");

  }, function() {
    var $overlay = $(this).closest(".border-container").find(".overlay");

    // de-animate overlay
    $overlay.removeClass("animate");

    // de-animate background
    $overlay.closest(".border-container").removeClass("animate");

  });

});